import type { SVGProps } from "react";

export const UserIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className="fill-current"
      {...props}
    >
      <path
        d="M15 13.5C15.9946 13.5 16.9481 13.8954 17.6514 14.5986C18.3546 15.3019 18.75 16.2554 18.75 17.25V18.75C18.75 19.1642 18.4142 19.5 18 19.5C17.5858 19.5 17.25 19.1642 17.25 18.75V17.25C17.25 16.6533 17.0128 16.0811 16.5908 15.6592C16.2217 15.29 15.7376 15.0619 15.2227 15.0107L15 15H9C8.40326 15 7.83114 15.2372 7.40918 15.6592C6.98722 16.0811 6.75 16.6533 6.75 17.25V18.75C6.75 19.1642 6.41421 19.5 6 19.5C5.58579 19.5 5.25 19.1642 5.25 18.75V17.25C5.25 16.2554 5.64537 15.3019 6.34863 14.5986C7.05189 13.8954 8.00544 13.5 9 13.5H15ZM12 4.5C14.0711 4.5 15.75 6.17893 15.75 8.25C15.75 10.3211 14.0711 12 12 12C9.92893 12 8.25 10.3211 8.25 8.25C8.25 6.17893 9.92893 4.5 12 4.5ZM12 6C10.7574 6 9.75 7.00736 9.75 8.25C9.75 9.49264 10.7574 10.5 12 10.5C13.2426 10.5 14.25 9.49264 14.25 8.25C14.25 7.00736 13.2426 6 12 6Z"
        fill="currentColor"
      />
    </svg>
  );
};
